module.exports = __webpack_public_path__ + "img/logo_lg_dark.be37e657.png";